
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title:
        "Explorez Tout ce qu'il faut Savoir sur le Street-Marketing: Définition et Conseils Utiles",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Découvrez la définition street-marketing, une stratégie marketing de proximité innovante pour attirer et engager les consommateurs dans l'environnement urbain.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content:
            "Explorez Tout ce qu'il faut Savoir sur le Street-Marketing: Définition et Conseils Utiles",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Découvrez la définition street-marketing, une stratégie marketing de proximité innovante pour attirer et engager les consommateurs dans l'environnement urbain.",
        },
      ],
    };
  },
};
